import styled from 'styled-components';
import Img from 'react-image';
import { Helmet } from 'react-helmet'
import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import {FrameContainer} from '../../styledComponents/layout';

export const MainVisual = styled(Img)`
max-height: 400px;
margin: 0 auto;
`;



export const SummaryContainer = styled.div`
  margin-top: 2vw;
  background: #ffffff;
  padding: 2vw;
  border-radius: 2.3vw;
  display: flex;
  flex-direction: column;
  img {
    object-fit: contain;
    margin: 1vw auto;
    max-height: 400px;
  }
  
  p {
    line-height: 2.4rem;
  }
  h2 {
    margin-bottom: 1rem;
    text-align: center;
    img {
      object-fit: contain;
      margin: 0;
      max-height: 100px;
      height:11.8vw;
    }
  }
	h3 {
		margin-bottom: 1rem;
    font-size: 3.0rem;
		text-align: left;
	}
`;
export const ContentsContainer = SummaryContainer.extend`
  margin-top: 0;
  padding: 0;
  background: transparent;
`
export const HowToApplyContainer = SummaryContainer.extend`
display: flex;
flex-direction: column;
align-items: center;
img {
  height: 8vw;
  max-height: 60px;
}

`;

export const QRCodeImage = styled(Img)`
  margin-top: 2vw;
  margin-bottom: 2vw;
`;

export const QRContainer = styled.div`
  margin-top: 2vw;
  border-radius: 2.3vw;
  display:flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  min-height: 200px;
`;
export const QRFooter = styled.div`
  height: 200px;
`;

export const QRHead = styled.h2`
  margin: 0;
  width: 100%;
  background-color: #9c0000;
  border-radius: 2.3vw 2.3vw 0 0;
  text-align: center;
  padding: 1vw;
  font-size: 2rem;
  color: #ffffff;
  line-height: 3rem;
`;

export const InvitationWrapper = styled.div`
  background: ${props => props.background};
`;
export const ContentsWrapper = styled.div`
  background: ${props => props.background};
`

export const MainVisualContainer = styled.div`
  background: ${props => props.background};

`;
export const EntertainerWrapper = styled.div`
  display:flex;
  flex-wrap: wrap;
  justify-content: center;
`;
export const EntertainerItem = styled.div`
  margin: 1%;
  flex-basis: 48%;
  text-align: center;
  max-width: 300px;

`;
export const EventAttention = () => (
  <SummaryContainer>
    <p>（会場・ホール内　入場・イベントについて）</p>
    <p>公演中の携帯電話は、公演の妨げになる為、また及び盗撮盗聴行為を防止させて頂くためホール内での携帯電話・カ メラ・録音機材の使用はご遠慮願います。不審な行動を発見したら確認させていただく場合も ございますので、ご了承くださいませ。万が一公演中の携帯電話の使用が必要となった場合は、 ホール外にてお願い申し上げます。</p>
    <p>主催側の認めたスタッフ以外による撮影・録音は厳禁となっております。お客様による携帯電 話、デジタルカメラ、ICレコーダー等による録音・撮影行為は発見し次第データクリアと退出とさせて頂きますので、こうした行為は絶対に行わないでください。</p>
    <p>本イベントでは、来場者の安全確保を目的に来場者手荷物検査を実施いたします。持込禁止物（下記参照）の会場内へのお持ち込みは固くお断りさせていただきます。会場内の安全管理上、皆様のご理解・ご協力をお願いいたします。</p>
    <p>（持込禁止物の一覧）</p>
    <p>銃器・刀剣・弓矢・鎖などの武器・武具類</p>
		<p>モデルガン・エアガン、ナイフ、アイスピック・千枚通し・針などのとがったもの、はさみ、など。または兜や鎧等の衣裳の装飾品も、とがっているものはこれに含みます。</p>
		<p>毒物・薬物・その他有害物質</p>
		<p>燃料、発炎筒、花火、火薬、多量のライター・マッチ等の可燃物や可燃性の高いもの</p>
		<p>ハンマー、ドライバー等、凶器として使用される恐れのあるもの</p>
		<p>酒類</p>
    <p>ペット、動物類（盲導犬、介助犬は除く）</p>
    <p>周囲に危害を加える恐れのあるもの</p>
    <p>自転車、ローラースケート、スケートボード</p>
    <p>ヨーヨー、ボール、円盤などの投げられるもの</p>
    <p>その他、スタッフが危険であると判断した物品</p>
    <p>　</p>
		<p>イベントへの再入場は基本お断りしております。やむを得ない理由で再入場を希望される方は、必ず近くのスタッフまでお声がけください。</p>
		<p>入場証等の転売行為、コピー、偽造は固く禁止いたします。特に偽造行為は犯罪に当たります。そのような行為を見つけ次第、警察に通報することもございますので、あらかじめご了承ください。</p>
    <p>入場証はイベント当日のみ有効とさせていただきます。</p>
		<p>イベントスペースにおける他方の場所取り行為は禁止とさせていただきます。</p>
		<p>飲酒、酒気帯びの方はイベント入場及び特典会への参加はできませんので、ご了承願います。</p>
		<p>劇場内での食事はご遠慮ください。お飲物はご自由にお持込いただけます。</p>
		<p>中学生は20時までとなりますので、時間によりイベントに参加出来ない場合がございます。(小学生以下入場不可）</p>
		<p>高校生は21時までとなりますので、時間によりイベントに参加出来ない場合がございます。</p>
		<p>体調不良及び妊婦のお客様は参加の有無を確認いたしますのでご了承ください。</p>
		<p>付添いが必要な身体障害者の方は係員にお尋ねください。</p>
		<p>入場証の紛失、盗難等による再発行はいたしませんので御了承ください。</p>
		<p>天災、交通ストライキなど不可抗力の事由によりイベント不可能と判断された場合は、イベントを中止いたします。</p>
		<p>イベント内容はメンバーの状況等により変更になる可能性がございます。あらかじめご了承ください。</p>
		<p>イベント中止・延期の場合、旅費などの補償はできません。</p>
		<p>開催日程および時間につきましては、都合により変更となる場合がございます。</p>
		<p>本イベントの安全な運営の為、主催者側がイベントに参加するにふさわしくないと判断した場合、特定のお客様にご参加をお断りする場合がございます。あらかじめご了承ください。</p>
		<p>イベント当日、取材等により、カメラが入る可能性がございます。お客様が映りこむ可能性もございますので、あらかじめご了承ください。</p>
		<p>イベント会場での荷物での場所取り行為は禁止いたします。</p>
		<p>イベント前日からの泊まり込みは近隣のご迷惑となりますので、禁止とさせていただきます。</p>
		<p>列の割り込み行為や仲間、友人による列取り行為は禁止いたします。</p>
		<p>荷物による列場所取り行為は禁止いたします。</p>
		<p>　</p>
		<p>≪上記行為が発覚した場合はイベントを中止する場合もございます≫</p>
		<p>--------------------------------------------------------------------------------</p>
		<p>イベント内容は予告無く変更される場合がございます。あらかじめご了承ください。</p>
	</SummaryContainer>
);

export const Summary = (props) => {
  let event = props.event;
  if(event.html.summary) {
    return(
		  <SummaryContainer> {event.html.summary.map((paragraph) => (ReactHtmlParser(paragraph))) } </SummaryContainer>
    );
  }
};

export const HowToApply = (props) => {
  let event = props.event;
  if(event.enableApply) {
    return(
      <HowToApplyContainer>
        <h2>参加方法</h2>
        <p>１．Flick!On!TVアプリをダウンロード（無料）</p>
        <a href={props.data.site.siteMetadata.firebaseDynamicLink}>
          <Img src={"/event/img/download_button.png"}/>
        </a>
        <Img src={"/event/img/bottom_arrow.png"}/>
        <p>２．会員登録（右上のアイコン→設定→プロフィール）</p>
        <Img src={"/event/img/bottom_arrow.png"}/>
        <p>３．会員限定番組観覧ご招待のお知らせバナーをタップ</p>
        <Img src={"/event/img/bottom_arrow.png"}/>
        <p>４．「参加申し込み」をタップ</p>
        <Img src={"/event/img/bottom_arrow.png"}/>
        <p>５．当日、会場受け付けでQRコードをご提示ください</p>
      </HowToApplyContainer>
    );
  } else {
    return(
      <HowToApplyContainer>
        <h2>申し訳ございません。このイベントの募集は終了いたしました。</h2>
      </HowToApplyContainer>
    );

  }
};

export const EventInvitation = ({event}) => {
  return (
    <InvitationWrapper background={event.html.background}>
      <Helmet title={event.title} />
      {event.html.contents.map((paragraph) => (ReactHtmlParser(paragraph)))}
      <FrameContainer>
        {event.html.summary && <SummaryContainer> event.html.summary.map((paragraph) => (ReactHtmlParser(paragraph))) </SummaryContainer> }
        <QRContainer>
          <QRHead>受付でQRコードをご掲示ください</QRHead>
          <QRCodeImage src={event.QRCodeUrl}/>
        </QRContainer>
        <QRFooter/>
      </FrameContainer>
    </InvitationWrapper>
  );
}

export const EventDetail = ({event, ...props}) => {
  if(event.html) {
    return(
      <ContentsWrapper background={event.html.background}>
        <Helmet title={event.title} />
        {event.html.contents.map((paragraph) => (ReactHtmlParser(paragraph)))}
        <FrameContainer>
          {event.html.summary && <Summary event={event} {...props} />}
          {event.html.summary && <HowToApply event={event} {...props} /> }
          <EventAttention/>
        </FrameContainer>
      </ContentsWrapper>
    );
  }
  return(
    <div></div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Event/index.js